import React, { useEffect, useState } from 'react';
import './Gallery.css';
import { getGalleryImages, resolveImageUrl } from '../api';

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        setLoading(true);
        const res = await getGalleryImages({ page, limit: 12 });
        setItems(res?.data?.items || []);
        setTotal(res?.data?.total || 0);
      } catch (err) {
        console.error('Failed to load gallery', err);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / 12));

  return (
    <section className="section gallery-section" id="gallery">
      <div className="container">
        <div className="section-header">
          <p className="section-tag">Moments</p>
          <h2 className="section-title">Gallery</h2>
          <p className="section-subtitle">
            A rotating view of selected captures and visuals from my journey.
          </p>
        </div>

        {loading ? (
          <div className="no-projects">
            <p>Loading gallery...</p>
          </div>
        ) : items.length === 0 ? (
          <div className="no-projects">
            <p>No gallery images yet.</p>
          </div>
        ) : (
          <>
            <div className="gallery-grid">
              {items.map((item) => (
                <div key={item._id} className="gallery-card" onClick={() => setSelected(item)}>
                  <img src={resolveImageUrl(item.imageUrl)} alt={item.title} loading="lazy" />
                  <div className="gallery-card__overlay">
                    <div className="gallery-card__content">
                      <h3 className="gallery-card__title">{item.title}</h3>
                      <p className="gallery-card__meta">{item.category || 'Gallery'}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="gallery-pagination">
                {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((num) => (
                  <button
                    key={num}
                    className={num === page ? 'active' : ''}
                    onClick={() => setPage(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
            )}
          </>
        )}

        {selected && (
          <div className="gallery-lightbox" onClick={() => setSelected(null)}>
            <div className="gallery-lightbox__content" onClick={(e) => e.stopPropagation()}>
              <button className="gallery-lightbox__close" onClick={() => setSelected(null)}>×</button>
              <img src={selected.imageUrl} alt={selected.title} />
              <div className="gallery-card__content" style={{ marginTop: '1rem' }}>
                <h3 className="gallery-card__title" style={{ color: '#fff' }}>{selected.title}</h3>
                {selected.description && <p style={{ color: '#e5e7eb' }}>{selected.description}</p>}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
